
import { MenuProps } from "antd";

const dataFormatKeyLabel: { [key: string]: string } = {
    'YYYY-MM-DD': '年-月-日',
    'YYYY/MM/DD': '年/月/日',
    'MM-DD-YYYY': '月-日-年',
    'MM/DD/YYYY': '月/日/年',
    'DD-MM-YYYY': '日-月-年',
    'DD/MM/YYYY': '日/月/年',
    'YYYYMMDD': '年月日',
    'YYYY-MM-DD HH:mm': '年-月-日 时:分',
    'HH:mm': '时:分',
    'HH:mm:ss': '时:分:秒',
}

const menuItems: MenuProps['items'] = [
    {
        label: '年-月-日',
        key: 'YYYY-MM-DD',
    },
    {
        label: '年/月/日',
        key: 'YYYY/MM/DD',
    },
    {
        label: '月-日-年',
        key: 'MM-DD-YYYY',
    },
    {
        label: '月/日/年',
        key: 'MM/DD/YYYY',
    },
    {
        label: '日-月-年',
        key: 'DD-MM-YYYY',
    },
    {
        label: '日/月/年',
        key: 'DD/MM/YYYY',
    },
    {
        label: '年月日',
        key: 'YYYYMMDD',
    },
    {
        label: '年-月-日 时:分',
        key: 'YYYY-MM-DD HH:mm',
    },
    {
        label: '时:分',
        key: 'HH:mm',
    },
    {
        label: '时:分:秒',
        key: 'HH:mm:ss',
    }
];

const customColors = [
    {
        label: '推荐颜色', colors: [
            '#FFFFFF',
            '#FDC1C8',
            '#FFD3A0',
            '#FEFFC9',
            '#CAF982',
            '#B5FFFF',
            '#76D6FF',
            '#C280FF',
            '#D7D7D7',
            '#FD8291',
            '#FFB053',
            '#FCFF79',
            '#95F204',
            '#34DDDD',
            '#02A7F0',
            '#8400FF',
            '#7F7F7F',
            '#FD091F',
            '#FB8800',
            '#FFFF00',
            '#70B603',
            '#00BFBF',
            '#02A5B4',
            '#6300BF',
            '#555555',
            '#B90915',
            '#BD6600',
            '#D5D900',
            '#4B7902',
            '#009393',
            '#005A80',
            '#4A0084',
            '#000000',
            '#68000C',
            '#864800',
            '#7E8001',
            '#335100',
            '#026C6C',
            '#004562',
            '#3C016A',
        ]
    }
]

function getDateFormatLabel(key: string) {
    return key in dataFormatKeyLabel ? dataFormatKeyLabel[key] : ''
}

export {
    menuItems,
    customColors,
    getDateFormatLabel,
}
